export default "__VITE_ASSET__Cpp9_vIx__"